import React, { useEffect, useMemo, useRef } from "react";
import { LatLngLiteral } from "leaflet";
import { Marker, Popup, Tooltip } from "react-leaflet";

import { trimText } from "../../../../lib/helpers/trimText";
import { TooltipName } from "../../../shared/TooltipName/TooltipName";
import { ContrastName } from "../../../shared/ContrastName/ContrastName";

export interface Props {
  position: LatLngLiteral;
  icon: L.Icon | L.DivIcon;
  name: string;
  type: string;
  isBooked: boolean;
  children?: React.ReactNode;
  defaultOpen?: boolean;
  onOpen?: () => void;
  scaleFactor?: number;
  hasContrastTooltips?: boolean;
  showTooltips?: boolean;
}

export const BookingsFloorMapMarker = ({
  position,
  children,
  defaultOpen,
  icon,
  name,
  type,
  isBooked,
  scaleFactor = 0.7,
  hasContrastTooltips = false,
  showTooltips = false,
}: Props) => {
  const markerRef = useRef<L.Marker>(null);

  useEffect(() => {
    let currentMarker = markerRef.current;

    if (currentMarker === null) {
      return;
    }

    if (defaultOpen === undefined && currentMarker.isPopupOpen()) {
      currentMarker.closePopup();
      return;
    }

    if (defaultOpen) {
      if (currentMarker.isPopupOpen()) {
        currentMarker.closePopup();
        return;
      }
      currentMarker.openPopup();
    }
  }, [defaultOpen]);

  const tooltipKey = useMemo(() => `tooltip-${scaleFactor}`, [scaleFactor]);

  return (
    <Marker icon={icon} ref={markerRef} position={position} draggable={false}>
      {showTooltips && type === "Room" && (
        <Tooltip
          key={tooltipKey}
          className={`room-permanent-tooltip`}
          direction="bottom"
          offset={[0, 2]}
          opacity={1}
          permanent
        >
          {hasContrastTooltips ? (
            <ContrastName
              name={trimText(name, 18)}
              scaleFactor={scaleFactor}
              isMarker
            />
          ) : (
            <TooltipName
              name={name}
              isBooked={isBooked}
              scaleFactor={scaleFactor}
            />
          )}
        </Tooltip>
      )}
      <Popup>{children}</Popup>
    </Marker>
  );
};
